import type { FunctionComponent } from "react";
import CreateBrandCommonPartial from "../../../partials/common/auth/create-brand.common.partials";

export const CreateBrandCommonScreen: FunctionComponent = () => {
	return <CreateBrandCommonPartial />;
};
